import React from "react";
import { string, node, oneOf } from "prop-types";
import { twMerge } from "tailwind-merge";

const SIZE = {
  HEIGHT: {
    xs: "h-2",
    sm: "h-3",
    default: "h-4",
    md: "h-6",
    lg: "h-9",
    xl: "h-12",
  },
  WIDTH: {
    xs: "w-2",
    sm: "w-3",
    default: "w-4",
    md: "w-6",
    lg: "w-9",
    xl: "w-12",
  },
};

const BaseIcon = ({ size = "md", className, children, fill, ...props }) => (
  <svg
    preserveAspectRatio="xMidYMid meet"
    className={twMerge(
      fill === "none" ? "fill-none" : "fill-current",
      SIZE.HEIGHT[size],
      SIZE.WIDTH[size],
      className
    )}
    {...props}
  >
    {children}
  </svg>
);

BaseIcon.propTypes = {
  children: node.isRequired,
  className: string,
  fill: string,
  size: oneOf(Object.keys(SIZE.HEIGHT)),
};

export default BaseIcon;
